<template>
  <div
    v-if="showInstallBanner"
    class="mx-auto max-w-lg absolute bottom-0 inset-x-0 pb-10 px-10 z-40"
  >
    <a
      class="w-full h-12 px-3 rounded-lg shadow-lg flex items-center justify-between bg-red-400 hover:bg-red-500 text-gray-800 hover:text-gray-900 cursor-pointer text-xl font-bold leading-none"
      @click.prevent="install"
    >
      <span class="flex-grow text-center">Install latest update!</span>
      <unicon
        name="times"
        class="w-8 h-8 text-gray-800 opacity-50 hover:opacity-100 focus:outline-none cursor-pointer"
        @click="handleClose"
      />
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'InstallPrompt',
  data() {
    return {
      showInstallBanner: false,
      installEvent: null
    }
  },
  created() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.installEvent = e
      this.showInstallBanner = true
      this.setFabVisible(false)
    })
  },
  methods: {
    ...mapActions('config', ['setFabVisible']),
    handleClose(event) {
      event && event.stopPropagation()
      this.close()
    },
    close() {
      this.showInstallBanner = false
      this.setFabVisible(true)
    },
    install() {
      if (!this.installEvent) return

      this.showInstallBanner = false
      this.setFabVisible(true)
      this.installEvent.prompt()
      this.installEvent.userChoice.then((result) => {
        console.log('Install Prompt result: ' + result.outcome)
        this.installEvent = null
      })
    }
  }
}
</script>
